import { useContext, useState } from 'react';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import CBUSelection from './CBUSelection';
import CBUClaim from './CBUClaim';

const PaymentMethodsAndBankAccounts = () => {
  const { currentStep } = useContext(ClaimContext);
  const [cbu, setCBU] = useState(null);

  switch (currentStep) {
    case 1:
      return <CBUSelection setCBU={setCBU} />;
    case 2:
      return <CBUClaim cbu={cbu} />;

    default:
      return <></>;
  }
};

export default PaymentMethodsAndBankAccounts;
